/* ============================================
   Product Hero Banner — Gallery, Variants, Cart
   ============================================ */

(function () {
  const section = document.querySelector('.product-hero-banner');
  if (!section) return;

  const jsonEl = section.querySelector('[data-product-json]');
  if (!jsonEl) return;

  const product = JSON.parse(jsonEl.textContent);
  const mainImage = section.querySelector('[data-main-media]');
  const thumbs = section.querySelectorAll('[data-thumb]');
  const optionBtns = section.querySelectorAll('[data-option-btn]');
  const priceEl = section.querySelector('[data-product-price]');
  const compareEl = section.querySelector('[data-compare-price]');
  const addBtn = section.querySelector('[data-add-to-cart]');
  const variantInput = section.querySelector('[data-variant-id]');
  const form = section.querySelector('[data-product-form]');
  const qtyInput = section.querySelector('[data-qty-input]');
  const qtyMinus = section.querySelector('[data-qty-minus]');
  const qtyPlus = section.querySelector('[data-qty-plus]');

  /* ---- Helpers ---- */

  function formatMoney(cents) {
    return '$' + (cents / 100).toFixed(2);
  }

  function getSelectedOptions() {
    var selected = {};
    product.options.forEach(function (name, i) {
      var active = section.querySelector('[data-option-index="' + i + '"].is-active');
      if (active) selected[i] = active.dataset.value;
    });
    return selected;
  }

  function findVariant(options) {
    return product.variants.find(function (v) {
      return product.options.every(function (name, i) {
        return v.options[i] === options[i];
      });
    });
  }

  /* ---- Gallery ---- */

  thumbs.forEach(function (thumb) {
    thumb.addEventListener('click', function () {
      var src = thumb.dataset.fullSrc;
      if (mainImage && src) {
        mainImage.src = src;
        mainImage.srcset = '';
      }
      thumbs.forEach(function (t) { t.classList.remove('is-active'); });
      thumb.classList.add('is-active');
    });
  });

  /* ---- Variant Selection ---- */

  function updateVariant(variant) {
    if (!variant) return;

    // Hidden input
    if (variantInput) variantInput.value = variant.id;

    // Price
    if (priceEl) priceEl.textContent = formatMoney(variant.price);

    // Compare at price
    if (compareEl) {
      if (variant.compare_at_price && variant.compare_at_price > variant.price) {
        compareEl.textContent = formatMoney(variant.compare_at_price);
        compareEl.style.display = '';
      } else {
        compareEl.style.display = 'none';
      }
    }

    // Add to cart availability
    if (addBtn) {
      if (variant.available) {
        addBtn.disabled = false;
        addBtn.textContent = 'ADD TO CART';
      } else {
        addBtn.disabled = true;
        addBtn.textContent = 'SOLD OUT';
      }
    }

    // Update URL
    var url = new URL(window.location);
    url.searchParams.set('variant', variant.id);
    window.history.replaceState({}, '', url);

    // Switch main image to variant featured image
    if (variant.featured_image && mainImage) {
      mainImage.src = variant.featured_image.src;
      mainImage.srcset = '';

      // Highlight matching thumbnail
      thumbs.forEach(function (t) {
        t.classList.toggle('is-active', t.dataset.mediaId === String(variant.featured_media_id));
      });
    }
  }

  optionBtns.forEach(function (btn) {
    btn.addEventListener('click', function () {
      var index = btn.dataset.optionIndex;

      // Update active state for this option group
      section.querySelectorAll('[data-option-index="' + index + '"]').forEach(function (b) {
        b.classList.remove('is-active');
      });
      btn.classList.add('is-active');

      // Find and apply matching variant
      var selected = getSelectedOptions();
      var variant = findVariant(selected);
      if (variant) updateVariant(variant);
    });
  });

  /* ---- Quantity ---- */

  if (qtyMinus) {
    qtyMinus.addEventListener('click', function () {
      var val = parseInt(qtyInput.value, 10);
      if (val > 1) qtyInput.value = val - 1;
    });
  }

  if (qtyPlus) {
    qtyPlus.addEventListener('click', function () {
      qtyInput.value = parseInt(qtyInput.value, 10) + 1;
    });
  }

  /* ---- AJAX Add to Cart ---- */

  if (form) {
    form.addEventListener('submit', function (e) {
      e.preventDefault();

      if (!addBtn || addBtn.disabled) return;

      var prevText = addBtn.textContent;
      addBtn.disabled = true;
      addBtn.textContent = 'ADDING...';

      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          id: parseInt(variantInput.value, 10),
          quantity: parseInt(qtyInput ? qtyInput.value : 1, 10)
        })
      })
        .then(function (res) {
          if (!res.ok) throw new Error('Add to cart failed');
          return res.json();
        })
        .then(function () {
          addBtn.textContent = 'ADDED!';
          document.dispatchEvent(new CustomEvent('cart:updated'));
          setTimeout(function () {
            addBtn.disabled = false;
            addBtn.textContent = prevText;
          }, 2000);
        })
        .catch(function () {
          addBtn.disabled = false;
          addBtn.textContent = prevText;
        });
    });
  }

  /* ---- Trust Signals Carousel (mobile dots) ---- */

  var trustGrid = section.querySelector('[data-trust-signals]');
  var trustDotsWrap = section.querySelector('[data-trust-dots]');
  var trustItems = trustGrid ? trustGrid.querySelectorAll('.product-hero-banner__trust-item') : [];

  if (trustGrid && trustDotsWrap && trustItems.length > 1) {
    var trustMql = window.matchMedia('(max-width: 768px)');
    var trustRaf = null;

    function buildTrustDots() {
      trustDotsWrap.innerHTML = '';
      for (var i = 0; i < trustItems.length; i++) {
        var dot = document.createElement('button');
        dot.type = 'button';
        dot.className = 'product-hero-banner__trust-dot' + (i === 0 ? ' is-active' : '');
        dot.setAttribute('aria-label', 'Go to slide ' + (i + 1));
        dot.dataset.index = i;
        trustDotsWrap.appendChild(dot);
      }
    }

    function getTrustActive() {
      var rect = trustGrid.getBoundingClientRect();
      var center = rect.left + rect.width / 2;
      var closest = 0, closestDist = Infinity;
      for (var i = 0; i < trustItems.length; i++) {
        var r = trustItems[i].getBoundingClientRect();
        var dist = Math.abs(r.left + r.width / 2 - center);
        if (dist < closestDist) { closestDist = dist; closest = i; }
      }
      return closest;
    }

    function updateTrustDots() {
      var idx = getTrustActive();
      trustDotsWrap.querySelectorAll('.product-hero-banner__trust-dot').forEach(function (d, i) {
        d.classList.toggle('is-active', i === idx);
      });
    }

    function scrollToTrust(index) {
      var item = trustItems[index];
      if (!item) return;
      var offset = item.offsetLeft - (trustGrid.offsetWidth - item.offsetWidth) / 2;
      trustGrid.scrollTo({ left: offset, behavior: 'smooth' });
    }

    function onTrustScroll() {
      if (trustRaf) cancelAnimationFrame(trustRaf);
      trustRaf = requestAnimationFrame(updateTrustDots);
    }

    function onTrustDotClick(e) {
      var dot = e.target.closest('.product-hero-banner__trust-dot');
      if (dot) scrollToTrust(parseInt(dot.dataset.index, 10));
    }

    function initTrustCarousel() {
      buildTrustDots();
      trustGrid.addEventListener('scroll', onTrustScroll, { passive: true });
      trustDotsWrap.addEventListener('click', onTrustDotClick);
    }

    function teardownTrustCarousel() {
      trustDotsWrap.innerHTML = '';
      trustGrid.removeEventListener('scroll', onTrustScroll);
      trustDotsWrap.removeEventListener('click', onTrustDotClick);
    }

    trustMql.addEventListener('change', function (e) {
      if (e.matches) { initTrustCarousel(); } else { teardownTrustCarousel(); }
    });

    if (trustMql.matches) initTrustCarousel();
  }

  /* ---- Description Accordion ---- */

  var descToggle = section.querySelector('[data-desc-toggle]');
  if (descToggle) {
    var descAccordion = descToggle.closest('.product-hero-banner__desc-accordion');
    descToggle.addEventListener('click', function () {
      var isOpen = descAccordion.classList.contains('is-open');
      descAccordion.classList.toggle('is-open', !isOpen);
      descToggle.setAttribute('aria-expanded', String(!isOpen));
    });
  }

  /* ---- Init: select variant from URL ---- */

  var params = new URLSearchParams(window.location.search);
  var variantId = params.get('variant');
  if (variantId) {
    var match = product.variants.find(function (v) { return String(v.id) === variantId; });
    if (match) {
      // Activate the correct option buttons
      match.options.forEach(function (val, i) {
        section.querySelectorAll('[data-option-index="' + i + '"]').forEach(function (b) {
          b.classList.toggle('is-active', b.dataset.value === val);
        });
      });
      updateVariant(match);
    }
  }
})();
